export const CLICK_TO_ADD_SECTION_LABLE = 'Click to add sections';
export const ADD_NEXT_LABEL = 'Add next';
